import { forwardRef } from 'react';
import { useStore } from '@ui-framework/index';
import SelectStatic from './SelectStatic';

const LanguageSelect = forwardRef(({ field, ...props }, ref) => {
  const store = useStore();
  const supportedLocales = store.domain.locale.getSupportedLocales();
  const options = supportedLocales.map(code => ({
    label: code.toUpperCase(),
    value: code,
    disabled: (field.disabledLanguages || []).includes(code),
  }));
  return (
    <SelectStatic
      ref={ref}
      field={field}
      customConfig={{ options }}
      {...props}
      permission={field.readOnly ? 'READ' : props.permission}
    />
  );
});

export default LanguageSelect;
